module.exports = __webpack_public_path__ + "img/appleRules.c0cb66a2.png";